/**
 * simulator-selector.js
 */
(function () {

  const SUPABASE = "https://nfghuenhuaecfyccyaib.supabase.co/storage/v1/object/public/svgs-thumbs/";

  // ── CSS ───────────────────────────────────────────────────────────────────────
  const STYLE = `
    .ks-model-grid { display: flex; flex-wrap:wrap; justify-content:center; gap:8px; margin-bottom:4px; }
    .ks-model-card {
      display:flex; flex-direction:column; align-items:center; gap:5px;
      background:rgba(255,255,255,.05); border:1.5px solid rgba(255,255,255,.1);
      border-radius:12px; padding:8px 6px; cursor:pointer; transition:all .18s;
      text-align:center; position:relative; width: 100%; height: 200px;
    }
    .ks-model-card:hover  { background:rgba(255,255,255,.1); transform:translateY(-2px); }
    .ks-model-card.active { border-color:#e94560 !important; background:rgba(233,69,96,.15); box-shadow:0 0 0 1px rgba(233,69,96,.3); }
    .ks-model-card img    { width:100%; height:90%; object-fit:contain; border-radius:8px; display:block; }
    .ks-model-fallback    { width:100%; height:90%; display:flex; align-items:center; justify-content:center; background:rgba(233,69,96,.15); border-radius:8px; font-size:22px; }
    .ks-model-name        { font-size:10px; font-weight:600; color:rgba(255,255,255,.8); line-height:1.3; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:68px; }
    .ks-model-card.active .ks-model-name { color:#e94560; }
    .ks-model-badge       { position:absolute; top:4px; right:4px; width:14px; height:14px; background:#e94560; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:8px; color:#fff; font-weight:800; }

    .ks-design-grid {  gap:8px; display: flex; flex-wrap:wrap; justify-content:center; }
    .ks-design-card {
      display:flex; flex-direction:column; align-items:center; gap:5px;
      background:rgba(0, 0, 0, 0.5); border:1.5px solid rgba(255,255,255,.1);
      border-radius:12px; padding:8px 6px; cursor:pointer; transition:all .18s; text-align:center; width: 100%; height: 200px;
    }
    .ks-design-card:hover  { background:rgba(255,255,255,.1); transform:translateY(-2px); }
    .ks-design-card.active { border-color:#e94560 !important; background:rgba(233,69,96,.15); box-shadow:0 0 0 1px rgba(233,69,96,.3); }
    .ks-design-card img    { width:100%; height:90%; object-fit:contain; border-radius:8px; display:block; }
    .ks-design-fallback    { width:100%; height:90%; display:flex; align-items:center; justify-content:center; background:rgba(255,255,255,.07); border-radius:8px; font-size:24px; }
    .ks-design-name        { font-size:10px; font-weight:600; color:rgba(255,255,255,.7); line-height:1.3; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:74px; }
    .ks-design-card.active .ks-design-name { color:#e94560; }
    .ks-empty { text-align:center; padding:24px 8px; font-size:12px; color:rgba(255,255,255,.3); }

    .ks-expand-btn {
      position: fixed; z-index: 999998; bottom: 16px; right: 16px;
      background: rgba(20,20,25,.85); color:#fff; border:1.5px solid rgba(255,255,255,.15);
      border-radius: 10px; padding: 10px 16px; font-size: 13px; font-weight: 600;
      display:flex; align-items:center; gap:8px; cursor:pointer; backdrop-filter: blur(6px);
      transition: all .15s;
    }
    .ks-expand-btn:hover { background: rgba(233,69,96,.85); border-color:#e94560; }

    .ks-fullscreen-overlay {
      position: fixed; inset: 0; z-index: 999999; background:#0b0d12;
      display:flex; flex-direction:column; padding: 70px 40px 50px; overflow-y:auto;
      box-sizing: border-box;
    }
    .ks-fullscreen-overlay * { box-sizing: border-box; }
    .ks-fullscreen-header { display:flex; align-items:center; justify-content:space-between; margin-bottom:32px; }
    .ks-fullscreen-header h2 { color:#fff; font-size:26px; font-weight:800; margin:0; }
    .ks-fullscreen-close {
      background: rgba(255,255,255,.08); border:1px solid rgba(255,255,255,.15); color:#fff;
      border-radius:10px; padding:10px 18px; cursor:pointer; font-size:13px; font-weight:600;
      transition: all .15s;
    }
    .ks-fullscreen-close:hover { background: rgba(233,69,96,.85); border-color:#e94560; }
    .ks-fullscreen-grid {
      display:grid; grid-template-columns: repeat(4, 1fr); gap:18px;
    }
    .ks-fullscreen-card {
      display:flex; flex-direction:column; align-items:center; gap:8px;
      background:rgba(255,255,255,.04); border:1.5px solid rgba(255,255,255,.1);
      border-radius:14px; padding:14px 10px; cursor:pointer; transition:all .18s; text-align:center;
    }
    .ks-fullscreen-card:hover { background:rgba(255,255,255,.09); transform:translateY(-3px); border-color:#e94560; }
    .ks-fullscreen-card.active { border-color:#e94560 !important; background:rgba(233,69,96,.15); box-shadow:0 0 0 1px rgba(233,69,96,.3); }
    .ks-fullscreen-card img { width:100%; aspect-ratio:1/1; object-fit:contain; border-radius:8px; display:block; }
    .ks-fullscreen-card span { font-size:12px; font-weight:600; color:rgba(255,255,255,.85); line-height:1.3; }

    @media (max-width: 900px) and (min-width: 641px) {
      .ks-fullscreen-grid { grid-template-columns: repeat(3, 1fr); }
    }

    @media (max-width: 640px) {
      .ks-fullscreen-overlay { padding: 60px 16px 40px; }
      .ks-fullscreen-header h2 { font-size: 20px; }
      .ks-fullscreen-grid { grid-template-columns: repeat(2, 1fr); gap: 12px; }
      .ks-expand-btn { bottom: 12px; right: 12px; padding: 8px 12px; font-size: 12px; }

      /* Lista de designs/modelagens no mobile: rolagem horizontal (arrasta
         pros lados) em vez de grid que quebra linha. */
      #designs-iframe-mobile .ks-design-grid,
      #modelagens-iframe-mobile .ks-model-grid {
        flex-wrap: nowrap;
        justify-content: flex-start;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        scroll-snap-type: x proximity;
        padding: 2px 4px 8px;
      }
      #designs-iframe-mobile .ks-design-card,
      #modelagens-iframe-mobile .ks-model-card {
        width: 110px;
        min-width: 110px;
        height: 150px;
        flex: 0 0 auto;
        scroll-snap-align: start;
      }
    }
  `;

  function injectStyles() {
    if (document.getElementById("ks-sel-styles")) return;
    const s = document.createElement("style");
    s.id = "ks-sel-styles"; s.textContent = STYLE;
    document.head.appendChild(s);
  }

  // ── Shared state ──────────────────────────────────────────────────────────────
  let allModelagens  = [];
  let activeIdx      = -1;   // selected model index
  let activeDesignId = null; // unique design id (item.id from dataArray)

  // ── Helpers ───────────────────────────────────────────────────────────────────
  function modelThumb(m) {
    if (m.thumb) return m.thumb;
    if (!m.path) return null;
    const hit = (window.dataArray || []).find(d => (d.sport_id||"").includes(m.path) && d.svg_thumb_path);
    return hit ? SUPABASE + hit.svg_thumb_path : null;
  }

  function designThumb(item) {
    return item.svg_thumb_path ? SUPABASE + item.svg_thumb_path : null;
  }

  function designsForModel(path) {
    if (!path) return [];
    return (window.dataArray || []).filter(d => (d.sport_id||"").includes(path));
  }

  // Get existing containers (desktop + mobile if present)
  function getWrap(baseid) {
    return [baseid, baseid + "-mobile"]
      .map(id => document.getElementById(id))
      .filter(Boolean);
  }

  // ── Sync active classes (called after state change) ───────────────────────────
  function syncModels() {
    document.querySelectorAll(".ks-model-card").forEach(c =>
      c.classList.toggle("active", parseInt(c.dataset.idx, 10) === activeIdx)
    );
  }

  function syncDesigns() {
    document.querySelectorAll(".ks-design-card").forEach(c =>
      c.classList.toggle("active", c.dataset.did === activeDesignId)
    );
  }

  // ── Build & insert design grid into all containers ────────────────────────────
  function renderDesigns(path, preselSportId) {
    const designs0 = designsForModel(path);
    if (preselSportId) {
      const hit = designs0.find(d => d.sport_id === preselSportId);
      activeDesignId = hit ? String(hit.id ?? "") || null : null;
    } else {
      activeDesignId = null;
    }
    const designs  = designs0;
    const wraps    = getWrap("designs-iframe");
    if (!wraps.length) return;

    if (!designs.length) {
      wraps.forEach(w => { w.innerHTML = `<div class="ks-empty">Nenhum design disponível</div>`; });
      return;
    }

    wraps.forEach(w => {
      const grid = document.createElement("div");
      grid.className = "ks-design-grid";

      designs.forEach(item => {
        const did  = String(item.id ?? "");   // unique per design row
        const sid  = item.sport_id || "";      // 3D model path (shared, used for loadDesign)
        const name = item.name || item.nome || item.title || "Design";
        const card = document.createElement("div");
        card.className   = "ks-design-card";
        card.dataset.did = did;   // unique — used for active state
        card.dataset.sid = sid;   // sport_id — passed to loadDesign
        if (did && did === activeDesignId) card.classList.add("active");

        const thumb = designThumb(item);
        card.innerHTML = (thumb
          ? `<img src="${thumb}" alt="${name}" onerror="this.outerHTML='<div class=\\'ks-design-fallback\\'>🎨</div>'">`
          : `<div class="ks-design-fallback">🎨</div>`)
          + `<span class="ks-design-name">${name}</span>`;

        card.addEventListener("click", () => {
          activeDesignId = did;
          syncDesigns();
          if (typeof window.loadDesign === "function") window.loadDesign(sid);
          const el = document.getElementById("kit-iframe-title");
          if (el) el.textContent = name;

          // ── Design info log ──────────────────────────────────────────────
          console.group(`%c🎨 Design selecionado: ${name}`, "color:#e94560;font-weight:bold;font-size:13px");
          console.groupEnd();

          window["manageLoads"](item.sport_id, item.svg_path);
        });
        grid.appendChild(card);
      });

      w.innerHTML = "";
      w.appendChild(grid);
    });
  }

  // ── Build & insert model grid into all containers ─────────────────────────────
  function renderModels() {
    const wraps = getWrap("modelagens-iframe");
    if (!wraps.length) return;

    if (!allModelagens.length) {
      wraps.forEach(w => { w.innerHTML = `<div class="ks-empty">Nenhuma modelagem no pedido</div>`; });
      return;
    }

    wraps.forEach(w => {
      const grid = document.createElement("div");
      grid.className = "ks-model-grid";

      allModelagens.forEach((entry, idx) => {
        const m    = entry.modelagem;
        const name = entry.nomePersonalizado || m.nome;
        const card = document.createElement("div");
        card.className  = "ks-model-card";
        card.dataset.idx = String(idx);
        if (idx === activeIdx) card.classList.add("active");

        const thumb = modelThumb(m);
        card.innerHTML = (thumb
          ? `<img src="${thumb}" alt="${name}" onerror="this.outerHTML='<div class=\\'ks-model-fallback\\'>👕</div>'">`
          : `<div class="ks-model-fallback">👕</div>`)
          + `<span class="ks-model-name">${name}</span>`
          + (entry.isDuplicate ? `<span class="ks-model-badge">C</span>` : "");

        card.addEventListener("click", () => {
          activeIdx = idx;
          syncModels();
          const selDsn = entry.personalizacao?.design?.path || null;
          renderDesigns(m.path || null, selDsn);
          if (typeof window.loadModel === "function") window.loadModel(m.path);
        });

        grid.appendChild(card);
      });

      w.innerHTML = "";
      w.appendChild(grid);
    });

    // After all containers rendered, trigger designs for the active model ONCE
    if (activeIdx >= 0 && allModelagens[activeIdx]) {
      const entry = allModelagens[activeIdx];
      renderDesigns(entry.modelagem.path || null, entry.personalizacao?.design?.path || null);
    }
  }

  // ── Expandir: botão + tela cheia com grid de todos os designs ─────────────────
  // Funciona com qualquer sistema que tenha populado #designs-iframe (tanto o
  // renderDesigns deste arquivo quanto o populateCategories do Loads.js) —
  // clona os cards existentes visualmente e, ao clicar, dispara um clique real
  // no card original, reaproveitando toda a lógica de seleção já existente.
  //
  // Botão flutuante, canto inferior direito (o inferior esquerdo é onde fica
  // o botão de voltar/expandir do preview 3D no mobile — ficavam sobrepostos).
  function ensureExpandButton() {
    if (document.getElementById("ks-expand-btn")) return;
    const btn = document.createElement("button");
    btn.id = "ks-expand-btn";
    btn.className = "ks-expand-btn";
    btn.innerHTML = "⤢ Ver todos";
    btn.addEventListener("click", openFullscreenDesigns);
    document.body.appendChild(btn);
  }

  function removeExpandButton() {
    const btn = document.getElementById("ks-expand-btn");
    if (btn) btn.remove();
  }

  function getDesignsSourceCards() {
    // Não basta pegar "o primeiro que existir" (document.getElementById(a)
    // || document.getElementById(b)) — se o container desktop existir no DOM
    // mas vazio (ex: só escondido por CSS), isso fazia o mobile (que tem os
    // cards de verdade) nunca ser considerado. Checa qual dos dois realmente
    // tem cards.
    const mobileSource = document.getElementById("designs-iframe-mobile");
    const mobileCards = mobileSource
      ? Array.from(mobileSource.children).filter(el => el.tagName === "DIV")
      : [];
    if (mobileCards.length > 0) return mobileCards;

    const desktopSource = document.getElementById("designs-iframe");
    if (!desktopSource) return [];
    // Filtra o próprio botão "Ver todos" (é um <button>, os cards são <div>).
    return Array.from(desktopSource.children).filter(el => el.tagName === "DIV");
  }

  function openFullscreenDesigns() {
    const originalCards = getDesignsSourceCards();
    if (!originalCards.length) return;

    document.getElementById("ks-fullscreen-overlay")?.remove();

    const overlay = document.createElement("div");
    overlay.id = "ks-fullscreen-overlay";
    overlay.className = "ks-fullscreen-overlay";

    const header = document.createElement("div");
    header.className = "ks-fullscreen-header";
    header.innerHTML = `<h2>Todos os Designs</h2>`;
    const closeBtn = document.createElement("button");
    closeBtn.className = "ks-fullscreen-close";
    closeBtn.textContent = "✕ Fechar";
    closeBtn.addEventListener("click", () => overlay.remove());
    header.appendChild(closeBtn);

    const grid = document.createElement("div");
    grid.className = "ks-fullscreen-grid";

    originalCards.forEach(orig => {
      const clone = document.createElement("div");
      clone.className = "ks-fullscreen-card" + (orig.classList.contains("active") ? " active" : "");
      clone.innerHTML = orig.innerHTML;
      clone.addEventListener("click", () => {
        orig.click(); // reaproveita a lógica de seleção do card original
        overlay.remove();
      });
      grid.appendChild(clone);
    });

    overlay.appendChild(header);
    overlay.appendChild(grid);
    document.body.appendChild(overlay);
  }

  // Observa #designs-iframe pra mostrar/esconder o botão automaticamente,
  // não importa qual sistema populou a lista (nem quando ela é recriada).
  // Também abre a tela cheia sozinha assim que os designs aparecem pela
  // primeira vez (ex: logo depois de escolher uma categoria) — só uma vez,
  // pra não ficar reabrindo toda hora que a lista for atualizada.
  let autoOpenTriggered = false;

  function watchDesignsPanel() {
    const check = () => {
      const hasCards = getDesignsSourceCards().length > 0;
      if (hasCards) {
        ensureExpandButton();
        if (!autoOpenTriggered) {
          autoOpenTriggered = true;
          openFullscreenDesigns();
        }
      } else {
        removeExpandButton();
      }
    };

    check();

    const observer = new MutationObserver(check);
    let observed = false;
    ["designs-iframe", "designs-iframe-mobile"].forEach(id => {
      const el = document.getElementById(id);
      if (el) { observer.observe(el, { childList: true, subtree: true }); observed = true; }
    });

    // O container pode ainda não existir quando este script carrega — tenta de novo.
    if (!observed) { setTimeout(watchDesignsPanel, 800); }
  }

  // ── Init ──────────────────────────────────────────────────────────────────────
  function init(orderJSON) {
    injectStyles();
    const json = orderJSON || window.__kingOrderJSON;
    if (!json) { console.warn("[ks-selector] No order JSON"); return; }

    allModelagens  = json.pedido?.modelagens || [];
    activeIdx      = allModelagens.length ? 0 : -1;
    activeDesignId = null;

    // renderModels() auto-selects first model which triggers renderDesigns()
    // Do NOT call renderDesigns() separately — would render twice causing multi-select
    renderModels();
  }

  window.addEventListener("kingsports:order", e => {
    setTimeout(() => init(e.detail), 100);
  });

  window.ksSelectorInit = init;

  // Call this when the mobile drawer opens to ensure divs are populated
  window.ksSelectorRefreshMobile = function() {
    if (!allModelagens.length) return;
    // renderModels auto-selects the active model and calls renderDesigns
    renderModels();
  };

  // Inicia a observação do painel de designs imediatamente — não depende do
  // fluxo de pedido (kingsports:order), então também funciona quando quem
  // populou #designs-iframe foi o populateCategories do Loads.js.
  injectStyles();
  watchDesignsPanel();


})();